// extracted by mini-css-extract-plugin
export var bodySections = "_dw-8";
export var gray = "_dw-7";
export var green = "_dw-4";
export var iconContainer = "_dw-9";
export var iconWidgetContainer = "_dw-1";
export var phoneIcon = "_dw-2";
export var red = "_dw-5";
export var statusDot = "_dw-3";
export var widgetContainer = "_dw-0";
export var yellow = "_dw-6";